var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mediaLibraryModalCard",class:{ mediaSelected: _vm.selected},on:{"click":_vm.onClick}},[_c('img',{attrs:{"src":_vm.src,"width":"150"}}),_vm._v(" "+_vm._s(_vm.media.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }